import React from 'react';
import { useUserInput } from '../../context/UserInputContext';
import DipssCalculator from './DipssCalculator';
import Mipss70Calculator from './Mipss70Calculator';

const MODELS: { id: 'dipss' | 'mipss70'; label: string }[] = [
  { id: 'dipss', label: 'DIPSS / DIPSS-Plus' },
  { id: 'mipss70', label: 'MIPSS-70+ v2.0' },
];

const MfRiskScores: React.FC = () => {
  const { state, update } = useUserInput();
  const selected = state.selectedMfRiskModel;

  return (
    <div className="mf-risk-scores">
      <div className="hema-input-group">
        <label className="hema-label" htmlFor="mf-risk-model">Risk Model</label>
        <div className="hema-field">
          <select
            id="mf-risk-model"
            value={selected}
            onChange={(e) => update('selectedMfRiskModel', e.target.value as 'dipss' | 'mipss70')}
          >
            {MODELS.map((m) => (
              <option key={m.id} value={m.id}>{m.label}</option>
            ))}
          </select>
        </div>
      </div>

      {selected === 'dipss' && <DipssCalculator />}
      {selected === 'mipss70' && <Mipss70Calculator />}
    </div>
  );
};

export default MfRiskScores;
